import { NavItemType } from 'types/menu';
import main from './main';
import admin from './admin';
import orders from './orders';
import products from './catalogue';
import integrations from './integrations';
import analytics from './analytics';
import advertising from './advertising';

// ==============================|| MENU ITEMS ||============================== //

const menuItems: { items: NavItemType[] } = {
  items: [main, orders, products, integrations, analytics, admin, advertising]
};

export default menuItems;
